<template>
    <section id="after-movies">
        <div class="secondary-heading text-center">ESSENS TURKEY 2025</div>
        <h1 class="text-center mb-5"> {{ $t('webVidea') }} </h1>
        <div id="after-movies-container" class="container px-5 position-relative">
            <div class="row">
                <div class="col-xs-12-mine col-lg-4 col-xl-4 pt-3">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/JY1geOKbn6o" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    </div> 
                </div>
                <div class="col-xs-12-mine col-lg-4 col-xl-4 pt-3">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/I3zLgv_3368" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-xs-12-mine col-lg-4 col-xl-4 pt-3">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/-R_MqaUF_ls" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                    </div> 
                </div>
            </div>
        </div>
    </section>
</template>

<style>
    #after-movies {
        background-color: var(--grey-bg);
    }
</style>